class LL_Slider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.js_slider');
    this.buttonPrev = this.querySelector('.js_sliderNavigationPrev');
    this.buttonNext = this.querySelector('.js_sliderNavigationNext');
    this.pagination = this.querySelector('.js_sliderPagination');
    this.sliderInstance = null; // Swiper instance placeholder
  }

  initializeSlider(sliderOptions) {
    if (!this.slider) {
      console.error('Slider element not found.');
      return;
    }

    // Ensure existing Swiper instance is destroyed before reinitializing
    if (this.sliderInstance) {
      this.sliderInstance.destroy(true, true);
    }

    // Initialize Swiper with provided settings
    this.sliderInstance = new Swiper(this.slider, {
      ...sliderOptions,
      ...(this.buttonPrev && this.buttonNext
        ? {
            navigation: {
              nextEl: this.buttonNext,
              prevEl: this.buttonPrev,
            },
          }
        : {}),
      ...(this.pagination
        ? {
            pagination: {
              el: this.pagination,
              clickable: true,
            },
          }
        : {}),
    });
  }
}

customElements.define('ll-slider', LL_Slider);